import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function clamp(min: number, value: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function isFirefox() {
  return navigator.userAgent.indexOf('Firefox') !== -1;
}

export function isSafari() {
  return navigator.userAgent.indexOf('Safari') !== -1;
}
